import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboardIcon, CarIcon, HomeIcon } from 'lucide-react';
interface AdminLayoutProps {
  children: React.ReactNode;
}
export function AdminLayout({
  children
}: AdminLayoutProps) {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  return <div className="flex min-h-screen bg-[var(--color-black-deep)]" data-id="element-11">
      {/* Sidebar */}
      <aside className="w-64 bg-[var(--color-black-rich)] border-r border-gray-800 flex flex-col" data-id="element-12">
        <div className="p-6 border-b border-gray-800" data-id="element-13">
          <h1 className="text-2xl font-bold text-white" data-id="element-14">Admin Panel</h1>
          <p className="text-sm text-gray-400 mt-1" data-id="element-15">Car Shop Management</p>
        </div>

        <nav className="flex-1 p-4" role="navigation" aria-label="Admin navigation" data-id="element-16">
          <ul className="space-y-2" data-id="element-17">
            <li data-id="element-18">
              <Link to="/admin" className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${isActive('/admin') ? 'bg-[var(--color-gold)] text-black font-medium' : 'text-gray-300 hover:bg-[var(--color-black-soft)] hover:text-white'}`} data-id="element-19">
                <LayoutDashboardIcon className="w-5 h-5" aria-hidden="true" data-id="element-20" />
                Dashboard
              </Link>
            </li>
            <li data-id="element-21">
              <Link to="/admin/vehicles" className={`${`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${isActive('/admin/vehicles') ? 'bg-[var(--color-gold)] text-black font-medium' : 'text-gray-300 hover:bg-[var(--color-black-soft)] hover:text-white'}`} text-[#ab2007]`} data-id="element-22">
                <CarIcon className="w-5 h-5" aria-hidden="true" data-id="element-23" />
                Vehicles
              </Link>
            </li>
          </ul>
        </nav>

        <div className="p-4 border-t border-gray-800" data-id="element-24">
          <Link to="/" className="flex items-center gap-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-[var(--color-black-soft)] hover:text-white transition-colors" data-id="element-25">
            <HomeIcon className="w-5 h-5" aria-hidden="true" data-id="element-26" />
            Back to Site
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto" data-id="element-27">{children}</main>
    </div>;
}